<template>
  <FloatingCard />
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient">
    <div class="container">
      <div class="d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div class="d-flex flex-column align-items-lg-start align-items-center">
          <div class="d-flex flex-lg-row flex-column align-items-center">
            <img src="@/assets/images/zoom-light.svg" width="100" class="pe-3" alt="" />
            <div class="text-white ps-lg-3 ps-0 d-flex align-items-center border-start meeting-title">
              <span class="fs-2 me-3 fw-bold">{{ title }}</span>
              <button data-bs-toggle="modal" data-bs-target="#addNewModal" class="btn edit-btn bg-light bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-3">
                <img src="@/assets/images/icons-Pencil-Line.svg" alt="" />
              </button>
            </div>
          </div>
          <div class="text-white text-lg-start text-center mt-3 opacity-75" style="max-width: 700px">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.</div>
        </div>
        <div class="d-lg-flex d-none flex-column flex-lg-row gap-3 align-items-center">
          <button class="btn btn-outline-light rounded-pill d-flex align-items-center fs-5">
            <div class="svg-icon me-2">
              <svg id="ic-content-copy-48px" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                <path id="Path_5" data-name="Path 5" d="M0,0H19V19H0Z" fill="none" />
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M14.988,2H5.57A1.574,1.574,0,0,0,4,3.579v11.05H5.57V3.579h9.418Zm2.355,3.157H8.709a1.574,1.574,0,0,0-1.57,1.579v11.05a1.574,1.574,0,0,0,1.57,1.579h8.633a1.574,1.574,0,0,0,1.57-1.579V6.736A1.574,1.574,0,0,0,17.342,5.157Zm0,12.629H8.709V6.736h8.633Z"
                  transform="translate(-2.365 -1.182)"
                  fill="currentColor"
                />
              </svg>
            </div>
            نسخ الرابط
          </button>
          <button class="bg-light btn bg-opacity-10 border rounded-pill d-flex align-items-center fs-5">
            <div class="switch-box light d-flex align-items-center">
              <input type="checkbox" checked="" id="switch" />
              <label for="switch">Toggle</label>
              <label class="text-white border-0 ms-2 unset-all" for="switch">إيقاف التفعيل</label>
            </div>
          </button>
          <div class="dropdown">
            <button class="btn p-0 dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <svg id="Group_1300" data-name="Group 1300" xmlns="http://www.w3.org/2000/svg" width="31" height="7" viewBox="0 0 31 7">
                <ellipse id="Ellipse_5" data-name="Ellipse 5" cx="3.562" cy="3.476" rx="3.562" ry="3.476" transform="translate(11.982)" fill="#e6e8ec" />
                <ellipse id="Ellipse_6" data-name="Ellipse 6" cx="3.5" cy="3.413" rx="3.5" ry="3.413" transform="translate(0 0.173)" fill="#e6e8ec" />
                <ellipse id="Ellipse_7" data-name="Ellipse 7" cx="3.5" cy="3.413" rx="3.5" ry="3.413" transform="translate(24 0.173)" fill="#e6e8ec" />
              </svg>
            </button>
            <ul class="dropdown-menu rounded-3 border-0 shadow-sm dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li>
                <button class="dropdown-item border-bottom" @click="successToast()" type="button">تعيين كإفتراضي</button>
              </li>
              <li>
                <button data-bs-toggle="modal" data-bs-target="#addteamModal" class="dropdown-item" type="button">حذف الكارد</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container mt-5">
    <!-- Item -->
    <Setting :id="1" :title="'الحد الأقصى للحجز'" :section_title="'بيانات الموعد'" :icon="require('@/assets/images/hourglass.svg')" :status="false" :subtitle="'يمكنك تحديد وقت لنهاية صلاحية هذا الموعد عبر تحديد عدد الأيام التي تريد للموعد الإنتهاء بعدها'" :visibility="false" :hasToggler="true">
      Nothing to see here!
    </Setting>
    <!-- Item -->
    <Setting :id="2" :title="`جدولة الأيام والمواعيد المتاح فيها الحدث `" :section_title="''" :icon="require('@/assets/images/schedule.svg')" :status="true" :subtitle="`لتخصيص الايام الأوقات التي تريد استقبال المواعيد فيها <a href='#' class='text-primary'>تعديل اوقات الدوام</a>`" :visibility="true" :hasToggler="true">
      <div class="radio-group radio-with-text d-inline-flex btn-group gap-3 mb-3" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio1" id="btnradio1" autocomplete="off" checked="" />
        <label class="btn form-control-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio1">أوقات الدوام</label>
        <input type="radio" class="btn-check" name="btnradio1" id="btnradio2" autocomplete="off" />
        <label class="btn form-control-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio2">مخصص</label>
      </div>
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingOne">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseOne" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne" />
              <label for="collapseOne">Toggle</label>
              <span class="fw-bold ms-3 fs-6">السبت</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseTwo" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo" />
              <label for="collapseTwo">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الأحد</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingThree">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseThree" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree" />
              <label for="collapseThree">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الإثنين</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingFour">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseFour" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour" />
              <label for="collapseFour">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الثلاثاء</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 mb-3 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingFive">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseFive" checked data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive" />
              <label for="collapseFive">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الأربعاء</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingFive">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item card border-2 p-3">
          <h2 class="accordion-header" id="panelsStayOpen-headingSix">
            <div class="switch-box primary d-flex align-items-center ms-auto">
              <input type="checkbox" id="collapseSix" checked data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="true" aria-controls="panelsStayOpen-collapseSix" />
              <label for="collapseSix">Toggle</label>
              <span class="fw-bold ms-3 fs-6">الخميس</span>
            </div>
          </h2>
          <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingSix">
            <div class="accordion-body px-0">
              <div class="d-flex align-items-center gap-4">
                <div class="start-date">
                  <label for="" class="fs-14px">من</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
                <div class="end-date">
                  <label for="" class="ps-lg-3 fs-14px">إلى</label>
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Setting>
    <!-- Item -->
    <Setting :id="3" :title="'عدد المرات التي يمكن حجز الموعد خلال اليوم'" :section_title="''" :icon="require('@/assets/images/clock.svg')" :status="true" :subtitle="'كم مرة تريد القيام بهذا الاجتماع خلال اليوم الواحد ؟'" :visibility="true" :hasToggler="true">
      <div class="radio-group radio-with-text d-inline-flex btn-group gap-lg-3 gap-2" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio2" id="btnradio3" autocomplete="off" checked="" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio3">30 دقيقة</label>
        <input type="radio" class="btn-check" name="btnradio2" id="btnradio4" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio4">ساعة</label>
        <input type="radio" class="btn-check" name="btnradio2" id="btnradio5" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio5">ساعة ونصف</label>
        <input type="radio" class="btn-check" name="btnradio2" id="btnradio6" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio6">مخصص</label>
      </div>
    </Setting>
    <!-- Item -->
    <Setting :id="4" :title="'وقت الإستراحة'" :section_title="'الإستراحة'" :icon="require('@/assets/images/layers.svg')" :status="true" :subtitle="'هل ترغب بإضافة وقت لنفسك قبل وبعد الاجتماع؟'" :visibility="true" :hasToggler="true">
      <div class="radio-group radio-with-text d-inline-flex flex-wrap btn-group gap-lg-3 gap-2 mb-3" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio4" id="btnradio7" autocomplete="off" checked="" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio7">كل يوم</label>
        <input type="radio" class="btn-check" name="btnradio4" id="btnradio8" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio8">مرتين</label>
        <input type="radio" class="btn-check" name="btnradio4" id="btnradio9" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio9">ثلاث مرات</label>
        <input type="radio" class="btn-check" name="btnradio4" id="btnradio19" autocomplete="off" />
        <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio19">ثلاث مرات</label>
      </div>
      <div class="d-flex align-items-lg-end align-items-start flex-lg-row flex-column gap-lg-0 gap-2">
        <div class="time-control">
          <label for="" class="fs-14px mb-1">كم من الوقت تحتاج قبل الإجتماع؟</label>
          <div class="d-flex align-items-center bg-light border border-2 time-select">
                  <div class="multiselect-custom-container">
                    <Multiselect class="mutliselect-custom form-control border-0" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
            <div class="time-title px-4">دقيقة</div>
          </div>
        </div>
        <div class="vertical-seperator d-lg-block d-none"></div>
        <div class="time-control">
          <label for="" class="fs-14px mb-1">كم من الوقت تحتاج بعد الإجتماع</label>
          <div class="d-flex align-items-center d-flex bg-light border border-2 time-select">
                  <div class="multiselect-custom-container">
                    <Multiselect class="mutliselect-custom form-control border-0" v-model="value" :placeholder="'إختر'" :searchable="true" :options="options" />
                  </div>
            <div class="time-title px-4">دقيقة</div>
          </div>
        </div>
      </div>
    </Setting>
    <!-- Item -->
    <Setting :id="5" :title="'أسئلة للضيف'" :section_title="'بيانات ماقبل الإجتماع'" :icon="require('@/assets/images/message.svg')" :status="true" :subtitle="'يمكنك إضافة بعض الأسئلة ليجيب عليها الضيف وقت حجز الموعد'" :visibility="false" :hasToggler="true">
      <draggable tag="ul" :list="list" class="list-group" handle=".handle" item-key="name">
        <template #item="{element, index}">
          <div class="add-input d-flex flex-lg-row flex-column align-items-lg-center gap-2 mb-3">
            <div type="button" class="p-0 handle d-none d-lg-block">
              <img src="@/assets/images/ic-arrow-hover-default.svg" alt="" />
            </div>
            <div class="d-flex align-items-center gap-3">
                  <div class="multiselect-custom-container">
                    <Multiselect class="form-control mutliselect-custom text-secondary ps-5" v-model="value" :placeholder="'النوع'" :searchable="true" :options="options" />
                  </div>
              <div type="button" class="p-0 handle d-block d-lg-none">
                <img src="@/assets/images/ic-arrow-hover-default.svg" alt="" />
              </div>
              <button type="button" class="btn p-0 close d-block d-lg-none" @click="removeAt(index)">
                <img src="@/assets/images/trash.2.svg" alt="" />
              </button>
            </div>
            <input type="text" class="form-control" placeholder="اكتب سؤالك" v-model="element.text" />
            <button type="button" class="btn p-0 close d-none d-lg-block" @click="removeAt(index)">
              <img src="@/assets/images/trash.2.svg" alt="" />
            </button>
          </div>
        </template>
      </draggable>
      <button @click="addNewQuestion" class="btn btn-outline-primary btn-lg bg-opacity-10 d-flex align-items-center rounded-pill fs-6" type="button">
        <div class="svg-icon me-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <g id="plus" transform="translate(-4 -4)">
              <path id="Line_1" data-name="Line 1" d="M-.086,13A.9.9,0,0,1-1,12.125V-.125A.9.9,0,0,1-.086-1a.9.9,0,0,1,.914.875v12.25A.9.9,0,0,1-.086,13Z" transform="translate(11.086 5)" fill="currentColor" />
              <path id="Line_2" data-name="Line 2" d="M12.125.828H-.125A.9.9,0,0,1-1-.086.9.9,0,0,1-.125-1h12.25A.9.9,0,0,1,13-.086.9.9,0,0,1,12.125.828Z" transform="translate(5 11.086)" fill="currentColor" />
            </g>
          </svg>
        </div>
        إضافة سؤال
      </button>
    </Setting>
    <!-- Item -->
    <Setting :id="6" :title="'رابط مخصص'" :section_title="'تخصيص الشكل'" :icon="require('@/assets/images/link.svg')" :status="false" :subtitle="'هذا الخيار يتيح لك تحديد شكل الرابط الذي تريد مشاركته'" :visibility="false" :hasToggler="true">Nothing to see here!</Setting>
    <!-- Item -->
    <Setting :id="8" :title="'لون الواجهة'" :section_title="'null'" :icon="require('@/assets/images/color-palette.svg')" :status="true" :subtitle="'هذا الخيار يتيح لك تحديد لون مخصص لهذا الحدث'" :visibility="true" :hasToggler="true">
      <div class="d-flex align-items-center">
        <div class="radio-group radio-with-color d-lg-inline-flex btn-group gap-3 align-items-center" role="group" aria-label="Basic radio toggle button group">
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio12" autocomplete="off" />
          <label class="btn circle-btn p-0" for="btnradio12"><div class="green-theme circle"></div></label>
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio13" autocomplete="off" />
          <label class="btn circle-btn p-0" for="btnradio13"><div class="primary-theme circle"></div></label>
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio14" autocomplete="off" />
          <label class="btn circle-btn p-0" for="btnradio14"><div class="gray-theme circle"></div></label>
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio15" autocomplete="off" />
          <label class="btn circle-btn p-0" for="btnradio15"><div class="dark-theme circle"></div></label>
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio17" autocomplete="off" />
          <label class="btn circle-btn p-0" for="btnradio17"><div class="orange-theme circle"></div></label>
          <input type="radio" class="btn-check" name="btnradio10" id="btnradio10" autocomplete="off" />
          <label class="btn btn-lg d-flex align-items-center justify-content-center text-black fs-14px" for="btnradio10">مخصص</label>
        </div>
      </div>
    </Setting>
  </div>

  <!-- Modal -->
  <Modal :form_img="false" :modal_img="require('@/assets/images/bookmark-plus_2x.png')" :modal_title="'تعديل اللقاء'" :name="'addNew'">
    <form>
      <div class="mt-3">
        <label for="title" class="fs-14px text-dark mb-2">العنوان</label>
        <input type="text" name="title" class="form-control bg-transparent border-2" v-model="title" />
      </div>
      <div class="mt-3">
        <div class="mb-1">
          <label for="platform" class="fs-14px text-black mb-2">منصة اللقاء</label>
        </div>
        <div class="radio-group radio-with-icon btn-group d-flex gap-2 justify-content-between" role="group" aria-label="Basic radio toggle button group">
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio1"><img src="@/assets/images/zm-02_2x.png" width="50" alt="" /></label>
            <span class="fs-14px">Zoom</span>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio2"><img src="@/assets/images/MaskGroup1_2x.png" width="40" alt="" /></label>
            <span class="fs-14px">Google Meet</span>
          </div>

          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio3"><img src="@/assets/images/google-location.png" width="40" alt="" /></label>
            <span class="fs-14px">إجتماع فيزيائي</span>
          </div>

          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio4" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio4"><img src="@/assets/images/ic-phone-24px.svg" width="28" alt="" /></label>
            <span class="fs-14px">مكالمة هاتفية</span>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <label for="details" class="fs-14px text-black mb-2">وصف قصير</label>
        <textarea name="details" rows="5" class="form-control"></textarea>
      </div>
      <div class="mt-3 d-grid">
        <button class="btn btn-primary text-white rounded-pill" type="submit">تعديل</button>
      </div>
    </form>
  </Modal>
</template>

<script>
let id = 3
import {ref} from '@vue/reactivity'
import Setting from '../components/Setting.vue'
import FloatingCard from '../components/FloatingCard.vue'
import Modal from '../components/Modal.vue'
import {computed} from '@vue/runtime-core'
import draggable from 'vuedraggable'
import Multiselect from '@vueform/multiselect'

export default {
  name: 'Details',
  components: {Setting, FloatingCard, draggable, Modal, Multiselect},
  setup() {
    const title = ref('الإستشارة على الموقع')
    const dragging = ref(false)

    const options = ref(['12:00', '12:30', '1:00', '1:30'])

    const draggInfo = computed(() => {
      return dragging ? 'under drag' : ''
    })
    const list = ref([
      {text: 'من هم منافسك في هذا المجال؟', id: 0},
      {text: '', id: 1},
      {text: '', id: 2},
    ])

    const removeAt = (idx) => {
      list.value.splice(idx, 1)
    }
    const addNewQuestion = () => {
      id++
      list.value.push({id, text: ''})
    }

    return {title, addNewQuestion, removeAt, draggInfo, list, options}
  },
}
</script>